import { useMediaQueryDetector } from '../useMediaQueryDetector'

export const useMobileDetector = () => {
  const { isMediaQueryDetected } = useMediaQueryDetector('(max-width: 550px)')

  return {
    isMobile: isMediaQueryDetected,
  }
}
